export function signedPercentPoints(value: number, places: number): number {
  if (!Number.isFinite(value) || value === 0) return 0;
  const factor = 10 ** places;
  const abs = Math.abs(value) * factor;
  const nearest = Math.round(abs);
  const atoms = Math.abs(abs - nearest) < 1e-6 ? nearest : value > 0 ? Math.floor(abs + 1e-9) : Math.ceil(abs - 1e-9);
  return (value > 0 ? atoms : -atoms) / factor;
}

export function signedPercentLabel(value: number, places: number, withPlus: boolean): string {
  const shown = signedPercentPoints(value, places);
  const text = shown.toFixed(places);
  return withPlus && shown > 0 ? `+${text}` : text;
}

export function lossMagnitudeLabel(value: number, places: number): string {
  const shown = Math.abs(signedPercentPoints(-Math.abs(value), places));
  return shown.toFixed(places);
}
